// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2HA_9","name":"ConsentHeader_name__29TjW","birthday":"ConsentHeader_birthday__2GA63","skeleton":"ConsentHeader_skeleton__10g8X"};